<app-loader *ngIf="isDisabled"></app-loader>
<div class="card border-radius-0 mt-1 p-0">
    <div class="card-header">
        <div class="card-title">
            CTC Reimbursement History
        </div>
    </div>
    <div class="card-body">
        <form class="g-3" name="filterForm" (ngSubmit)="Validate(filterForm)" #filterForm="ngForm" novalidate>
            <div class="row pb-2">
                <div class="col-md-3">
                    <label for="ApprovalStatus" class="form-font-label">Status</label>
                    <select class="form-select" aria-label="ApprovalStatus" placeholder="Status" title="Status"
                        name="Status" data-live-search="true" (change)="Clear()" [(ngModel)]="Filter.ApprovalStatus"
                        #ApprovalStatus="ngModel" required>
                        @for (status of common.ReimbursementStatus; track status.Value; let i = $index) {
                        <option [value]="status.Value">
                            <div class="row">
                                <div class="col">{{status.Name}}</div>
                            </div>
                        </option>
                        }
                    </select>
                    <div class="invalid-feedback">
                        Please select status!
                    </div>
                </div>
                <div class="col-md-2 px-1"><br>
                    <div class="form-check ms-3">
                        <input type="checkbox" class="form-check-input" id="checkbox" [(ngModel)]="Filter.IsCheckedbox"
                            name="chf" (change)="Clear()">
                        <label class="form-check-label" for="checkbox">Include Date</label>
                    </div>
                </div>
                <div class="col-md-3 px-1" *ngIf="Filter.IsCheckedbox">
                    <label class="Label">Month and Year</label>
                    <ngb-datepicker #dp [(ngModel)]="selectedMonth" class="month-year"
                        (navigate)="selectedMonth= $event.next;onNavigate();Clear()" (ngModelChange)="Clear()"
                        name="dateselect" style="width: 80%;"></ngb-datepicker>
                </div>
                <div class="col-md-auto mt-4">
                    <button type="submit" class="btn btn-primary" [disabled]="isDisabled">
                        <i class="bi bi-search" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Search':'Loading...'}}
                    </button>
                </div>
            </div>
        </form>
        <div class="row">
            <div class="btn-group gap-1" role="group" aria-label="Basic example">
                <button type="button" class="btn btn-outline-primary" style="width:100%"
                    [class.active]="Filter.EmpType === 'front'" (click)="FilterEmpType('front')" value="front">
                    Front Office
                </button>
                <button type="button" class="btn btn-outline-primary" [class.active]="Filter.EmpType === 'back'"
                    (click)="FilterEmpType('back')" style="width:100%" value="back"> Back Office
                </button>
            </div>
        </div>
        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th scope="col" style="width: 5px;">#</th>
                    <th>Employee</th>
                    <th style="width: 200px;">{{this.Filter.EmpType == 'front'?'Client Location':this.Filter.EmpType
                        ==
                        'back'?'Branch Name':''}}</th>
                    <th style="width: 50px;">RequestDate</th>
                    <th style="width: 50px;">Bill Amount</th>
                    <th style="width: 50px;">Claimed Amount</th>
                    <th style="width: 10px;">Outstanding Amount</th>
                    <th style="width: 50px;">Month Year</th>
                    <th style="width: 10px;">Reimbursement Type</th>
                    <th style="width: 50px;">Remark</th>
                    <th style="width: 50px;">Is Reimbursed</th>
                    <th style="width: 100px;">Attachment</th>
                    <th>Approval</th>
                    <th>Status</th>
                    <!-- <th style="width: 5px;" style="display: none;">View</th> -->
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let TableData of TableDatas; let i = index">
                    <th scope="row" style="width: 5px;">{{i+1}}</th>
                    <td>
                        <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                            <div class="col-2">
                                <img *ngIf="TableData['Photo'] != null && TableData['Photo'] != ''" mat-card-image
                                    class="userImage" [src]="common.PhotoLink(TableData['Photo'])" />
                                <div *ngIf="TableData['Photo'] == null || TableData['Photo'] == ''"
                                    class="initial-image">
                                    <div class="image">
                                        {{common.getInitial(TableData['EmployeeName'])}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-9 userdetail">
                                <span class="text-label">{{TableData['EmployeeName']}}</span><br />
                                <span class="text-label-light">#{{TableData['EmpCode']}}</span><br />
                                <span class="text-label-light">{{TableData['DesignationName']}}</span>
                            </div>
                        </div>
                    </td>

                    <td style="width: 200px;">
                        <div style="width: 200px;">{{this.Filter.EmpType ==
                            'front'?TableData['ClientLocation']:this.Filter.EmpType ==
                            'back'?TableData['BranchName']:''}}</div>
                    </td>
                    <td style="width: 50px;">{{TableData['RequestDate'] }}</td>
                    <td style="width: 50px;">{{TableData['BillAmount'] }}</td>
                    <td style="width: 50px;">{{TableData['ClaimedAmount'] }}</td>
                    <td style="width: 10px;">{{TableData['OutstandingAmount']}}</td>
                    <td style="width: 50px;">{{TableData['MonthYear']}}</td>
                    <td style="width: 10px;">{{TableData['ReimbursementType']}}</td>
                    <td style="width: 50px;">{{TableData['Remark']}}</td>
                    <td style="width: 50px;">{{TableData['IsReimbursed'] == true ? 'Yes' : 'No'}}</td>
                    <td class="attachmentThumbTD">
                        <app-thumbnail-attachment
                            *ngIf="TableData['Attachment'] != null && TableData['Attachment'] != ''"
                            [attachmentUrl]="Link(TableData['Attachment'])">
                        </app-thumbnail-attachment>
                    </td>
                    <td style="width: 5px; text-align: center;" [ngClass]="{'colHide': !this.common.PageRight.IsView}">
                        <div style="width: 60px;"><button type="button" (click)="viewApprovalMatrix(i)"
                                class="btn btn-outline-primary btn-sm"><i class="bi bi-eye me-1"></i></button></div>
                    </td>
                    <td><span class="badge"
                            [ngClass]="{'success':common.ToLowerCase(TableData['ApprovalStatus']) == 'approved', 'warning':common.ToLowerCase(TableData['ApprovalStatus']) == 'pending','danger':common.ToLowerCase(TableData['ApprovalStatus']) == 'rejected'}">{{TableData['ApprovalStatus']}}</span>
                    </td>
                    <!-- <td style="width: 5px;" style="display: none;">
                        <div style="width: 70px;"><button type="button" class="btn btn-outline-primary btn-sm"
                                [routerLink]="['/todo/reimbursementapproval/detail/', TableData['ESS_ReimbursementRequestId']]"><i
                                    class="bi bi-info-square me-1"></i>View</button></div>
                    </td> -->
                </tr>
            </tbody>
        </table>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button (click)="ExcelDump()" class="btn btn-primary btn-sm">
                    <i class="bi bi-download me-1"></i>Excel
                </button>
            </div>
        </div>
    </div>
</div>